import React from "react";
import { IResourceComponentsProps } from "@refinedev/core";
import { Edit, useForm, useSelect } from "@refinedev/antd";
import { Form, Input, Select } from "antd";
import { ILanguage, IStore } from "interfaces";

export const RegionEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult, onFinish } = useForm();
  const regionsData = queryResult?.data?.data;
  const { selectProps: langSelectProps } = useSelect<ILanguage>({
    resource: "languages",
    optionLabel: "name",
    optionValue: "id",
  });

  const { selectProps: storeSelectProps } = useSelect<IStore>({
    resource: "stores",
    optionLabel: "name",
    optionValue: "id",
  });

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical"
        onFinish={(values: any) => {
          const result = {
            name: values.name,
            language: values.languageEdit,
            stores: values.storesEdit.map((id: number) => ({ id })),
          }
          onFinish(result).catch((error) => error)
        }}
      >
        <Form.Item
          label="Id"
          name={["id"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input readOnly disabled />
        </Form.Item>
        <Form.Item
          label="Name"
          name={["name"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Language"
          name='languageEdit'
          rules={[
            {
              required: true,
            }
          ]}
          initialValue={[regionsData?.language?.id]}
        >
          <Select
            {...langSelectProps}
            allowClear
          />
        </Form.Item>
        <Form.Item
          label="Store(s)"
          name='storesEdit'
          rules={[
            {
              required: true,
            }
          ]}
          initialValue={regionsData?.stores?.map((item: IStore) => item.id)}
        >
          <Select
            {...storeSelectProps}
            allowClear
            mode="multiple"
          />
        </Form.Item>
      </Form>
    </Edit>
  );
};
